/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins';

// Components
import { registerGlobalComponents } from '@/plugins/global-components';
import { createApp } from 'vue';
import App from './App.vue';
import { skeletonDirective } from './directives/DirectiveSkeleton.js';

// Composables
const app = createApp(App);
registerGlobalComponents(app);

registerPlugins(app);

app.directive('skeleton', skeletonDirective);

app.mount('#app');
